var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-feed-section-empty"},[_c('h1',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_c('MoleculeFeedSectionEmpty')],1)}
var staticRenderFns = []

export { render, staticRenderFns }